export const SELECTED_CICLO_CHANGED = 'SELECTED_CICLO_CHANGED'

export function selectedCicloChanged(
  cicloId,
  cicloName,
  empresaId,
  file_type_id,
  operationcenter_id,
  empresaDeId,
) {
  return {
    type: SELECTED_CICLO_CHANGED,
    payload: { cicloId, cicloName, empresaId, empresaDeId, file_type_id, operationcenter_id },
  }
}
